// Lead form settings shared by the white paper and contact forms.

// Web3Forms access keys are public by design (they only let a form send to Linus's inbox), so this
// one ships in the client bundle. Server secrets stay in Vercel env vars, read only by api/lead.js.
// To change it, paste the key from web3forms.com here; an empty string turns the browser path off.
export const WEB3FORMS_PUBLIC_KEY = '15fe9936-7e21-42ab-b905-5410df3de528';

export const WEB3FORMS_SUBMIT_URL = 'https://api.web3forms.com/submit';
